<template>
  <div>
    <div class="i-toolbar clearfix" role="navigation" aria-label="Page Header">
      <div class="i-toolbar-title"><h1>{{ LANG.storedSettings }}</h1></div>
    </div>

    <div class="i-one-panel-view">
      <div class="i-one-panel-view-content clearfix">
        <table class="filelist" cellspacing="0" cellpadding="0" width="100%">
          <thead>
            <tr class="filelist-header">
              <th>{{ LANG.name }} </th>
              <th class="hidden-xs">{{ LANG.description }} </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="{id, desc} in userConfigs" :key="id" class="hover_row">
              <td>{{ id }} </td>
              <td class="hidden-xs">{{ desc }} </td>
              <td class="icon_cell">
                <i-button
                  compact
                  variant="secondary"
                  :title="`${LANG.deleteFile} ${id}`"
                  @click="selectedFileId=id, showDeleteConfirmation=true"
                >
                  {{ LANG.delete }}
                </i-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <i-modal :title="LANG.deleteFile" v-model:show="showDeleteConfirmation">
      {{ `${LANG.deleteConfigurationConfirm} '${selectedFileId}'?` }}
      <template #footer>
        <i-button variant="secondary" @click.prevent="showDeleteConfirmation=false">{{ LANG.cancel }}</i-button>
        <i-button variant="primary" @click.prevent="() => deleteConfig(selectedFileId)">{{ LANG.delete }}</i-button>
      </template>
    </i-modal>
  </div>
</template>

<script>
import useData, { fetcher, url } from '@/utils/useData';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { ascending, showToast } from '@/utils/tools';

export default {
  name: 'UserFilesPage',
  setup() {
    const store = useStore();
    const user = computed(() => store.state.user);
    const selectedFileId = ref(null);
    const showDeleteConfirmation = ref(false);

    const { data: userFiles, error, mutate: mutateUserFiles } = useData(url('/data/user_files'));

    const deleteFile = async (id) => {
      const response = await fetcher(url('/data/user_files/delete', { USER_ID: user.value.id, data_id: id }));
      showDeleteConfirmation.value = false;
      showToast(response.message, response.error);
      if (!response.error) {
        mutateUserFiles(() => userFiles.value.filter((file) => file.id !== id));
      }
    };

    const userSettings = computed(() => store.getters['roles/userSettings']);
    const deleteUserSettings = (id) => {
      store.dispatch('roles/resetUserSettings', { id });
      showDeleteConfirmation.value = false;
      showToast(store.state.LANG.successfullyDeletedUserSettings);
    };

    const deleteConfig = (id) => {
      const action = (userSettings.value || []).find((c) => c.id === id) ? deleteUserSettings : deleteFile;
      action(id);
    };
    const byId = (a, b) => ascending(a.id, b.id);
    const userConfigs = computed(() => [...(userSettings.value || []), ...(userFiles.value || [])].sort(byId));

    return {
      LANG: computed(() => store.state.LANG),
      showDeleteConfirmation,
      selectedFileId,
      deleteConfig,
      userConfigs,
      error,
    };
  },
};
</script>
